import {useMemo} from 'react';
import {
  ChartData,
} from 'chart.js';
import { originalColors } from '../constants/originalColors';
import { MongoDBMonthlyCostData } from '../constants/types';


export const useMongoDBMonthlyCostChartData=(fullLabels: string[], fullDataPoints: { month: string; [env: string]: number | string }[]): ChartData<'bar'> =>
useMemo(() => {
  const labels = fullLabels.slice(-3);
  const dataPoints = fullDataPoints.slice(-3);

  const envKeys = Object.keys(dataPoints[0] || {}).filter(key => key !== 'month');
    return {
        labels,
        datasets: envKeys.map((env, i) => (
          {
            label: env,
            data: dataPoints.map(item =>
          Number(item[env]) === 0 ? null : Number(item[env])),
            backgroundColor: originalColors[i],
            borderColor: 'rgb(255, 99, 132)',
            maxBarThickness: 10,
        })),
    };
  }, [fullLabels, fullDataPoints]);

   export const useMongoDBExpandedMonthlyCostChartData = (hasConfirmed: boolean, graphData: MongoDBMonthlyCostData[], initialData: MongoDBMonthlyCostData[]): ChartData<'bar'> =>
    useMemo(() => {
      const sourceData = hasConfirmed && graphData ? graphData : initialData;
  
      const filteredLabels = sourceData!.map(item => item.month); // ['01', '02', ...]
      const filteredDataPoints = sourceData.map(item => ({ month: item.month, ...item.cost })) as { [key: string]: number | string }[];
      const envKeys = Object.keys(filteredDataPoints[0] || {}).filter(key => key !== 'month');
      return {
        labels: filteredLabels,
        datasets: envKeys.map((env, i) => (
          {
            label: env,
            data: filteredDataPoints.map(item =>
          Number(item[env]) === 0 ? null : Number(item[env])),
            backgroundColor: originalColors[i],
            borderColor: 'rgb(255, 99, 132)',
            maxBarThickness: 10,
          })),
      };
    }, [hasConfirmed, graphData, initialData]);